import { Column } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const HeaderSection = ({
  isLoginMode,
  signupTitle,
  signupDescription,
}: {
  isLoginMode: boolean
  signupTitle?: string
  signupDescription?: string
}) => {
  const { t } = useLocalization()

  return (
    <Column className="gap-1.5">
      {isLoginMode ? (
        <h1 className="!leading-8">
          {t('Welcome back', 'Välkommen tillbaka')}
        </h1>
      ) : (
        <h1 className="!leading-8">
          {signupTitle ?? t("Let's get started", 'Låt oss komma igång')}
        </h1>
      )}

      {isLoginMode ? (
        <p>
          {t(
            'Use your work Google or Microsoft account, or we will email you a magic link.',
            'Använd ditt Google- eller Microsoft-jobbkonto, eller så mejlar vi en magisk länk.'
          )}
        </p>
      ) : (
        <p>
          {signupDescription ??
            t(
              'Sign up with your work Google or Microsoft account, or your work email.',
              'Registrera dig med ditt Google- eller Microsoft-jobbkonto, eller din arbetsmejl.'
            )}
        </p>
      )}
    </Column>
  )
}
